export function formatPrice(price, currencyISO, currencies) {
    if (!currencies) {
        return `${price} ?`;
    }
    const currency = currencies.find(c => c.alpha3ISO === currencyISO);
    price = currency ? price.toFixed(currency.decimalDigits) : 2;
    const symbol = currency ? currency.symbol : "?";
    return `${price} ${symbol}`;
}